import { StartupFunction } from ".";
import { DevPortalRoot } from "../compositionRoot";
import { BuildConfig } from "../util/buildConfig";

// Extend global to include the tdp property
declare global {
  interface Window {
    // THIS IS ONLY FOR DEBUGGING, DO NOT USE OUTSIDE OF THE DEV CONSOLE.
    tdp: DevPortalRoot | undefined;
    tdpConfig: BuildConfig | undefined;
  }
}

const targetEnvironments = ['development', 'local'];

/**
 * Attach the application root to the window for easier debugging from browser console.
 * @param root the developer portal application root
 * @param buildConfig the configuration object
 */
export const attachDevPortalConsoleTools: StartupFunction = (root, buildConfig) => {
  if (targetEnvironments.includes(buildConfig.environment ?? '')) {
    window.tdp = root;
    window.tdpConfig = buildConfig;

    // Ideally this would be done using zod, but at this stage it would've already thrown and I'm lazy w.r.t. development tools.
    const baseNamespace = (buildConfig.telemetry as { baseNamespace: string }).baseNamespace;
    window.localStorage.setItem('localStorage.debug', `${baseNamespace}:*`);
  }
};
